var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('back-btn'),_c('v-row',[_c('v-col',{attrs:{"lg":"12"}},[_c('patient-family-form',{attrs:{"familyMember":_vm.eachFamilyMember},on:{"emitData":_vm.submitData}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }